/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWeatherGrid
 */
export interface OutputWeatherGrid {
    /**
     * BandRadiusKm — ширина смуги збору по обидва боки від ЛБЗ.
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    bandRadiusKm?: number;
    /**
     * LastRebuiltAt — коли сітку востаннє перебудовували під зсув фронту.
     * @type {string}
     * @memberof OutputWeatherGrid
     */
    lastRebuiltAt?: string;
    /**
     * MaxNodeDistanceKm — найгірша відстань від довільної точки до вузла (півдіагональ комірки).
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    maxNodeDistanceKm?: number;
    /**
     * Модель-джерело та її власна роздільність — щоб було видно, наскільки сітка грубіша.
     * @type {string}
     * @memberof OutputWeatherGrid
     */
    modelName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    modelStepDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    modelStepKm?: number;
    /**
     * ModelUpdateHours — як часто модель випускає новий прогін.
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    modelUpdateHours?: number;
    /**
     * Points — скільки вузлів у сітці зараз.
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    points?: number;
    /**
     * StepDeg — крок сітки в градусах; StepLatKm/StepLngKm — він же в кілометрах на середній
     * широті смуги (комірка витягнута: градус довготи коротший за градус широти).
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    stepDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    stepLatKm?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWeatherGrid
     */
    stepLngKm?: number;
}

/**
 * Check if a given object implements the OutputWeatherGrid interface.
 */
export function instanceOfOutputWeatherGrid(value: object): boolean {
    return true;
}

export function OutputWeatherGridFromJSON(json: any): OutputWeatherGrid {
    return OutputWeatherGridFromJSONTyped(json, false);
}

export function OutputWeatherGridFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWeatherGrid {
    if (json == null) {
        return json;
    }
    return {
        
        'bandRadiusKm': json['bandRadiusKm'] == null ? undefined : json['bandRadiusKm'],
        'lastRebuiltAt': json['lastRebuiltAt'] == null ? undefined : json['lastRebuiltAt'],
        'maxNodeDistanceKm': json['maxNodeDistanceKm'] == null ? undefined : json['maxNodeDistanceKm'],
        'modelName': json['modelName'] == null ? undefined : json['modelName'],
        'modelStepDeg': json['modelStepDeg'] == null ? undefined : json['modelStepDeg'],
        'modelStepKm': json['modelStepKm'] == null ? undefined : json['modelStepKm'],
        'modelUpdateHours': json['modelUpdateHours'] == null ? undefined : json['modelUpdateHours'],
        'points': json['points'] == null ? undefined : json['points'],
        'stepDeg': json['stepDeg'] == null ? undefined : json['stepDeg'],
        'stepLatKm': json['stepLatKm'] == null ? undefined : json['stepLatKm'],
        'stepLngKm': json['stepLngKm'] == null ? undefined : json['stepLngKm'],
    };
}

export function OutputWeatherGridToJSON(value?: OutputWeatherGrid | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bandRadiusKm': value['bandRadiusKm'],
        'lastRebuiltAt': value['lastRebuiltAt'],
        'maxNodeDistanceKm': value['maxNodeDistanceKm'],
        'modelName': value['modelName'],
        'modelStepDeg': value['modelStepDeg'],
        'modelStepKm': value['modelStepKm'],
        'modelUpdateHours': value['modelUpdateHours'],
        'points': value['points'],
        'stepDeg': value['stepDeg'],
        'stepLatKm': value['stepLatKm'],
        'stepLngKm': value['stepLngKm'],
    };
}

